const svelteSheetsOptions = {
    tableHeight: '100%',
    tableWidth: '100%',
    defaultColWidth: 150,
    editable: false
};

export default svelteSheetsOptions;